import React, { useEffect, useState } from 'react';
import { RESOLUTION_TYPE } from '@atlassian/jira-platform-field-config';
import { CellWrapper } from '../../../common/cell-wrapper';
import type { TransformedResolutionField } from '../../../common/field-types/resolution';
import type { BasicListViewItem, FieldCellProps } from '../../../common/types';
import { ResolutionRead } from './read';

export const ResolutionCell = ({
	cellData: field,
}: FieldCellProps<BasicListViewItem, TransformedResolutionField>) => {
	const [resolution, setResolution] = useState(field?.value || null);

	useEffect(() => {
		setResolution(field?.value || null);
	}, [field?.value]);

	if (field == null) {
		return null;
	}

	const readContent = <ResolutionRead resolution={resolution} />;

	return (
		<CellWrapper isEditable={false} hasPadding>
			{readContent}
		</CellWrapper>
	);
};

export const resolutionCellHandler = {
	[RESOLUTION_TYPE]: ResolutionCell,
};
